import { TextField, TextFieldProps, Typography, useTheme } from '@mui/material'
import { TBet } from 'contexts/BetContext'

export const StakeInput = ({
    bet,
    ...props
}: TextFieldProps & { bet: TBet }) => {
    const theme = useTheme()
    const removeLeadingZero = bet.stake && bet.stake >= 1

    return (
        <TextField
            sx={{
                width: 85,
                ml: 1,
                backgroundColor: 'white'
            }}
            InputLabelProps={{
                sx: {
                    fontSize: 14,
                    '&:not(.MuiInputLabel-shrink)': {
                        mt: -0.25,
                        color: theme.palette.grey[500]
                    }
                }
            }}
            InputProps={{
                inputProps: {
                    sx: {
                        textAlign: 'right',
                        height: 16,
                        fontSize: 16
                    }
                },
                endAdornment: bet.stake ? (
                    <Typography sx={{ ml: 0.5, lineHeight: 'inherit' }}>
                        &#x20AC;
                    </Typography>
                ) : null
            }}
            variant="outlined"
            size="small"
            label="Mise"
            type="number"
            value={(bet.stake || '')
                .toString()
                .replace(removeLeadingZero ? /^0+/ : '', '')}
            {...props}
        />
    )
}
